/** @jsx h */
// ═══════════════════════════════════════════════════════
//  Clipboard Utility with fallback
// ═══════════════════════════════════════════════════════

export function copyToClipboard(text, onSuccess, onError) {
	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(text)
			.then(() => {
				if (onSuccess) onSuccess();
			})
			.catch(() => {
				// Fallback for non-secure contexts
				fallbackCopy(text, onSuccess, onError);
			});
	} else {
		fallbackCopy(text, onSuccess, onError);
	}
}

function fallbackCopy(text, onSuccess, onError) {
	const textarea = document.createElement('textarea');
	textarea.value = text;
	textarea.style.position = 'fixed';
	textarea.style.left = '-9999px';
	textarea.style.top = '0';
	document.body.appendChild(textarea);
	textarea.focus();
	textarea.select();
	
	try {
		const success = document.execCommand('copy');
		if (success && onSuccess) {
			onSuccess();
		} else if (!success && onError) {
			onError(new Error('execCommand returned false'));
		}
	} catch (err) {
		if (onError) onError(err);
	} finally {
		document.body.removeChild(textarea);
	}
}
